const CACHE_STORAGE_KEY = 'raffle_multiplier_cache';
const CACHE_TTL_MS = 5 * 60 * 1000;

export function loadCacheFromStorage() {
    const cache = new Map();

    try {
        const raw = sessionStorage.getItem(CACHE_STORAGE_KEY);

        if (!raw) {
            return cache;
        }

        const stored = JSON.parse(raw);
        const now = Date.now();

        Object.keys(stored).forEach((path) => {
            const entry = stored[path];

            if (entry && now - entry.ts < CACHE_TTL_MS) {
                cache.set(path, entry.value);
            }
        });
    } catch (e) {
        // Corrupted or unavailable storage -- start fresh
    }

    return cache;
}

export function saveCacheToStorage(cache) {
    try {
        const obj = {};
        const now = Date.now();

        cache.forEach((value, path) => {
            obj[path] = { value, ts: now };
        });

        sessionStorage.setItem(CACHE_STORAGE_KEY, JSON.stringify(obj));
    } catch (e) {
        // Storage full or unavailable -- silently ignore
    }
}
